(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["garrnish-password-page"]) return;
  try {
    
  if (!customElements.get('garrnish-password-page')) {
    customElements.define(
      'garrnish-password-page',
      class GarrnishPasswordPage extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';

          this.openButtons = this.querySelectorAll('[data-gpp-dialog-open]');
          this.dialogs = this.querySelectorAll('[data-gpp-dialog]');
          this.inlineAccess = this.querySelector('[data-gpp-inline-access]');
          this.inlineTrigger = this.querySelector('[data-gpp-inline-trigger]');
          this.inlineForm = this.querySelector('.garrnish-password-inline-form');
          this.inlineInput = this.querySelector('[data-gpp-inline-input]');
          this.inlineSubmit = this.querySelector('[data-gpp-inline-submit]');
          this.inlineSubmitLabel = this.querySelector('[data-gpp-inline-submit-label]');
          this.inlineLoadingStatus = this.querySelector('[data-gpp-inline-loading-status]');
          this.inlineError = this.querySelector('[data-gpp-inline-error]');
          this.countdown = this.querySelector('[data-gpp-countdown]');
          this.accessActions = this.querySelector('[data-gpp-access-actions]');
          this.waitlistTrigger = this.querySelector('[data-gpp-waitlist-trigger]');
          this.phaseMode = this.dataset.phaseMode || 'automatic';
          this.videos = Array.from(this.querySelectorAll('.garrnish-password-page__video'));
          this.soundButton = this.querySelector('[data-gpp-sound-toggle]');
          this.klaviyoContainer = this.querySelector('.garrnish-password-dialog__klaviyo');
          this.waitlistDialog = this.klaviyoContainer?.closest('[data-gpp-dialog]');
          this.waitlistEyebrow = this.waitlistDialog?.querySelector('[data-gpp-waitlist-eyebrow]');
          this.waitlistHeading = this.waitlistDialog?.querySelector('[data-gpp-waitlist-heading]');
          this.waitlistDescription = this.waitlistDialog?.querySelector('[data-gpp-waitlist-description]');
          this.mobileQuery = window.matchMedia('(max-width: 899px)');
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.soundEnabled = false;
          this.klaviyoPhoneErrorVisible = false;
          this.handleMediaChange = () => this.syncVideos();
          this.handleDocumentPointerDown = (event) => {
            if (this.inlineAccess?.dataset.open !== 'true') return;
            if (this.inlineForm?.dataset.loading === 'true') return;
            if (this.inlineAccess.contains(event.target)) return;
            if (this.inlineInput?.value) return;
            this.setInlineAccessOpen(false, false);
          };
          this.handleInlineFocusOut = () => {
            window.requestAnimationFrame(() => {
              if (this.inlineFocusPending) return;
              if (this.inlineAccess?.dataset.open !== 'true') return;
              if (this.inlineForm?.dataset.loading === 'true') return;
              if (this.inlineAccess.contains(document.activeElement)) return;
              if (this.inlineInput?.value) return;
              this.setInlineAccessOpen(false, false);
            });
          };
          this.handleKlaviyoPhoneAction = (event) => {
            const isSubmitClick = event.type === 'click' && event.target.closest('button.klaviyo-form-button');
            const isSubmitEvent = event.type === 'submit';
            const isEnterKey = event.type === 'keydown' && event.key === 'Enter';
            if (!isSubmitClick && !isSubmitEvent && !isEnterKey) return;

            const input = this.findKlaviyoPhoneInput();
            if (!input) return;
            if (!this.validateKlaviyoPhone(input)) {
              event.preventDefault();
              event.stopImmediatePropagation();
              input.focus();
              return;
            }

            this.normalizeKlaviyoPhone(input);
          };
          this.handleKlaviyoFormEvent = (event) => {
            const detail = event.detail || {};
            const formId = detail.formId || detail.formID;
            if (detail.type !== 'submit' || formId !== this.klaviyoContainer?.dataset.gppKlaviyoFormId) return;
            this.setKlaviyoSuccessState(true);
          };

          this.openButtons.forEach((button) => {
            button.addEventListener('click', () => this.openDialog(button));
          });

          if (this.inlineTrigger) {
            this.inlineTrigger.addEventListener('click', () => this.setInlineAccessOpen(true));
          }

          if (this.inlineInput) {
            this.inlineInput.addEventListener('input', () => this.clearInlineError());
            this.inlineInput.addEventListener('keydown', (event) => {
              if (event.key !== 'Escape') return;
              event.preventDefault();
              event.stopPropagation();
              this.setInlineAccessOpen(false);
            });
          }

          if (this.inlineAccess) {
            this.inlineAccess.addEventListener('focusout', this.handleInlineFocusOut);
            document.addEventListener('pointerdown', this.handleDocumentPointerDown);
          }

          if (this.inlineForm) {
            this.inlineForm.addEventListener('submit', () => this.setInlineLoading(true));
          }

          this.dialogs.forEach((dialog) => {
            dialog.querySelectorAll('[data-gpp-dialog-close]').forEach((button) => {
              button.addEventListener('click', () => dialog.close());
            });

            dialog.addEventListener('click', (event) => {
              if (event.target === dialog) dialog.close();
            });

            dialog.addEventListener('close', () => {
              const trigger = this.querySelector(`[aria-controls="${dialog.id}"]`);
              if (trigger) trigger.focus();
            });
          });

          if (this.soundButton) {
            this.soundButton.addEventListener('click', () => this.toggleSound());
          }

          if (this.klaviyoContainer) {
            this.klaviyoContainer.addEventListener('click', this.handleKlaviyoPhoneAction, true);
            this.klaviyoContainer.addEventListener('submit', this.handleKlaviyoPhoneAction, true);
            this.klaviyoContainer.addEventListener('keydown', this.handleKlaviyoPhoneAction, true);
            window.addEventListener('klaviyoForms', this.handleKlaviyoFormEvent);
            this.klaviyoObserver = new MutationObserver(() => {
              this.enhanceKlaviyoPhone();
              this.updateKlaviyoSubmitLabel();
            });
            this.klaviyoObserver.observe(this.klaviyoContainer, { childList: true, subtree: true });
            this.enhanceKlaviyoPhone();
            this.updateKlaviyoSubmitLabel();
          }

          this.mobileQuery.addEventListener('change', this.handleMediaChange);
          this.motionQuery.addEventListener('change', this.handleMediaChange);

          const invalidPassword = this.querySelector('input[name="password"][aria-invalid="true"]');
          const waitlistSuccess = this.querySelector('[data-gpp-waitlist-success]');
          const invalidWaitlist = this.querySelector('input[name="contact[email]"][aria-invalid="true"]');

          if (this.inlineAccess && this.inlineTrigger && this.inlineForm) {
            this.inlineAccess.dataset.inlineReady = 'true';
            this.inlineTrigger.hidden = false;
            this.setInlineAccessOpen(Boolean(invalidPassword), Boolean(invalidPassword));
          }
          if (waitlistSuccess || invalidWaitlist) {
            this.showDialog((waitlistSuccess || invalidWaitlist).closest('dialog'));
          }

          this.syncVideos();
          this.startCountdown();
        }

        disconnectedCallback() {
          if (this.countdownTimer) window.clearInterval(this.countdownTimer);
          this.mobileQuery?.removeEventListener('change', this.handleMediaChange);
          this.motionQuery?.removeEventListener('change', this.handleMediaChange);
          this.inlineAccess?.removeEventListener('focusout', this.handleInlineFocusOut);
          document.removeEventListener('pointerdown', this.handleDocumentPointerDown);
          this.klaviyoContainer?.removeEventListener('click', this.handleKlaviyoPhoneAction, true);
          this.klaviyoContainer?.removeEventListener('submit', this.handleKlaviyoPhoneAction, true);
          this.klaviyoContainer?.removeEventListener('keydown', this.handleKlaviyoPhoneAction, true);
          window.removeEventListener('klaviyoForms', this.handleKlaviyoFormEvent);
          this.klaviyoObserver?.disconnect();
          this.videos?.forEach((video) => video.pause());
        }

        setKlaviyoSuccessState(isSuccess) {
          if (!this.waitlistDialog || !this.waitlistEyebrow) return;

          const label = isSuccess
            ? this.waitlistEyebrow.dataset.successLabel
            : this.waitlistEyebrow.dataset.defaultLabel;
          if (label) this.waitlistEyebrow.textContent = label;
          if (this.waitlistHeading) this.waitlistHeading.hidden = isSuccess;
          if (this.waitlistDescription) this.waitlistDescription.hidden = isSuccess;
          this.waitlistDialog.dataset.gppWaitlistSuccess = String(isSuccess);

          const labelledBy = isSuccess ? this.waitlistEyebrow.id : this.waitlistHeading?.id;
          if (labelledBy) this.waitlistDialog.setAttribute('aria-labelledby', labelledBy);
        }

        findKlaviyoPhoneInput() {
          return this.klaviyoContainer?.querySelector('input[id^="mobile_number_"]') || null;
        }

        getKlaviyoPhoneDigits(input) {
          const digits = input.value.replace(/\D/g, '');
          const localDigits = digits.startsWith('65') && digits.length > 8 ? digits.slice(2) : digits;
          return localDigits.slice(0, 8);
        }

        setKlaviyoPhoneValue(input, value, shouldNotify = false) {
          const valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
          if (valueSetter) {
            valueSetter.call(input, value);
          } else {
            input.value = value;
          }

          if (shouldNotify) {
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        prepareKlaviyoPhoneForEditing(input, shouldNotify = false) {
          const field = input.parentElement;
          const localDigits = this.getKlaviyoPhoneDigits(input);
          if (field) field.dataset.gppNormalized = 'false';
          input.maxLength = 8;
          input.pattern = '[89][0-9]{7}';
          this.setKlaviyoPhoneValue(input, localDigits, shouldNotify);
        }

        normalizeKlaviyoPhone(input) {
          const field = input.parentElement;
          const localDigits = this.getKlaviyoPhoneDigits(input);
          if (field) field.dataset.gppNormalized = 'true';
          input.maxLength = 11;
          input.pattern = '\\+65[89][0-9]{7}';
          this.klaviyoPhoneNormalizing = true;
          this.setKlaviyoPhoneValue(input, `+65${localDigits}`, true);
          this.klaviyoPhoneNormalizing = false;
        }

        validateKlaviyoPhone(input) {
          const isValid = /^[89][0-9]{7}$/.test(this.getKlaviyoPhoneDigits(input));
          const field = input.parentElement;
          const errorMessage = 'Please use a valid 8-digit Singapore mobile number.';
          this.klaviyoPhoneErrorVisible = !isValid;
          input.setCustomValidity(isValid ? '' : errorMessage);
          input.setAttribute('aria-invalid', String(!isValid));
          if (isValid) {
            input.removeAttribute('aria-description');
          } else {
            input.setAttribute('aria-description', errorMessage);
          }
          if (field) {
            field.dataset.gppPhoneInvalid = String(!isValid);
            field.dataset.gppPhoneErrorMessage = errorMessage;
          }

          return isValid;
        }

        enhanceKlaviyoPhone() {
          const input = this.findKlaviyoPhoneInput();
          if (!input || input.dataset.gppSingaporePhoneReady === 'true') return;

          const field = input.parentElement;
          if (!field) return;
          input.dataset.gppSingaporePhoneReady = 'true';
          field.dataset.gppSingaporePhone = 'true';
          field.dataset.gppNormalized = 'false';
          field.style.setProperty('--gpp-klaviyo-phone-height', `${input.getBoundingClientRect().height || 52}px`);
          input.inputMode = 'numeric';
          input.autocomplete = 'tel-national';
          input.placeholder = '8123 4567';
          input.setAttribute('aria-label', 'Singapore mobile number, country code plus 65');
          field.dataset.gppPhoneInvalid = String(this.klaviyoPhoneErrorVisible);
          field.dataset.gppPhoneErrorMessage = 'Please use a valid 8-digit Singapore mobile number.';

          const isNormalized = /^\+65[89][0-9]{7}$/.test(input.value);
          if (isNormalized) {
            field.dataset.gppNormalized = 'true';
            input.maxLength = 11;
            input.pattern = '\\+65[89][0-9]{7}';
          } else {
            this.prepareKlaviyoPhoneForEditing(input, Boolean(input.value));
          }
          if (this.klaviyoPhoneErrorVisible) this.validateKlaviyoPhone(input);

          input.addEventListener('focus', () => {
            if (field.dataset.gppNormalized === 'true' || /^\+65/.test(input.value)) {
              this.prepareKlaviyoPhoneForEditing(input, true);
            }
          });
          input.addEventListener('input', () => {
            if (this.klaviyoPhoneNormalizing) return;
            this.prepareKlaviyoPhoneForEditing(input);
            if (/^[89][0-9]{7}$/.test(input.value) || this.klaviyoPhoneErrorVisible) {
              this.validateKlaviyoPhone(input);
            }
          });
          input.addEventListener('paste', () => {
            window.requestAnimationFrame(() => this.prepareKlaviyoPhoneForEditing(input, true));
          });
        }

        openDialog(button) {
          this.setInlineAccessOpen(false, false);
          const dialog = this.querySelector(`#${CSS.escape(button.dataset.gppDialogOpen)}`);
          this.showDialog(dialog);
        }

        setInlineAccessOpen(isOpen, shouldFocus = true) {
          if (!this.inlineAccess || !this.inlineTrigger || !this.inlineForm) return;
          this.inlineFocusPending = isOpen && shouldFocus;
          if (isOpen) this.syncInlineStart();
          if (!isOpen) {
            this.setInlineLoading(false);
            this.clearInlineError();
          }
          this.inlineAccess.dataset.open = String(isOpen);
          this.inlineTrigger.setAttribute('aria-expanded', String(isOpen));
          this.inlineTrigger.hidden = isOpen;
          this.inlineForm.hidden = !isOpen;

          if (!shouldFocus) {
            this.inlineFocusPending = false;
            return;
          }
          const focusTarget = isOpen ? this.inlineInput : this.inlineTrigger;
          if (focusTarget) {
            window.requestAnimationFrame(() => {
              focusTarget.focus();
              this.inlineFocusPending = false;
            });
          } else {
            this.inlineFocusPending = false;
          }
        }

        clearInlineError() {
          if (this.inlineError) this.inlineError.hidden = true;
          if (this.inlineInput) {
            this.inlineInput.removeAttribute('aria-invalid');
            this.inlineInput.removeAttribute('aria-describedby');
          }
        }

        syncInlineStart() {
          if (!this.inlineAccess || !this.inlineTrigger || this.inlineTrigger.hidden) return;
          const accessRect = this.inlineAccess.getBoundingClientRect();
          const triggerRect = this.inlineTrigger.getBoundingClientRect();
          const start = Math.max(0, triggerRect.left - accessRect.left);
          const end = Math.max(0, accessRect.right - triggerRect.right - 44);
          this.inlineAccess.style.setProperty('--gpp-inline-start', `${start}px`);
          this.inlineAccess.style.setProperty('--gpp-inline-end', `${end}px`);
        }

        setInlineLoading(isLoading) {
          if (!this.inlineForm) return;
          this.inlineForm.dataset.loading = String(isLoading);
          if (this.inlineInput) this.inlineInput.readOnly = isLoading;
          if (this.inlineSubmit) {
            this.inlineSubmit.disabled = isLoading;
            this.inlineSubmit.setAttribute('aria-busy', String(isLoading));
            const loadingLabel = this.inlineLoadingStatus?.dataset.loadingLabel;
            if (isLoading && loadingLabel) this.inlineSubmit.setAttribute('aria-label', loadingLabel);
            if (!isLoading && this.inlineSubmitLabel) {
              this.inlineSubmit.setAttribute('aria-label', this.inlineSubmitLabel.textContent.trim());
            }
          }
          if (this.inlineLoadingStatus) {
            this.inlineLoadingStatus.textContent = isLoading ? this.inlineLoadingStatus.dataset.loadingLabel || '' : '';
          }
        }

        showDialog(dialog) {
          if (!dialog || dialog.open) return;
          this.dialogs.forEach((openDialog) => {
            if (openDialog.open) openDialog.close();
          });
          dialog.showModal();
          const focusTarget = dialog.querySelector('input') || dialog.querySelector('button');
          if (focusTarget) window.requestAnimationFrame(() => focusTarget.focus());
        }

        syncVideos() {
          if (!this.videos.length) return;

          this.activeVideo = this.videos.find((video) => window.getComputedStyle(video).display !== 'none') || null;
          if (!this.activeVideo) this.soundEnabled = false;

          this.videos.forEach((video) => {
            if (video !== this.activeVideo) {
              video.pause();
              video.muted = true;
              return;
            }

            video.muted = !this.soundEnabled;
            if (!this.motionQuery.matches || this.soundEnabled) {
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => {});
            } else {
              video.pause();
            }
          });

          this.updateSoundButton();
        }

        toggleSound() {
          if (!this.activeVideo) return;
          this.soundEnabled = !this.soundEnabled;
          this.videos.forEach((video) => {
            video.muted = true;
          });
          this.activeVideo.muted = !this.soundEnabled;
          const playPromise = this.activeVideo.play();
          if (playPromise) playPromise.catch(() => {});
          this.updateSoundButton();
        }

        updateSoundButton() {
          if (!this.soundButton) return;
          this.soundButton.hidden = !this.activeVideo;
          this.soundButton.dataset.sound = this.soundEnabled ? 'on' : 'off';
          this.soundButton.setAttribute(
            'aria-label',
            this.soundEnabled ? this.soundButton.dataset.soundOffLabel : this.soundButton.dataset.soundOnLabel
          );
        }

        setLaunchPhase(phase) {
          const presaleEnded = phase === 'ended';
          const nextPhase = phase === 'live' ? 'live' : 'waitlist';
          this.dataset.launchPhase = nextPhase;
          this.dataset.presaleEnded = String(presaleEnded);
          this.setPostPresaleState(presaleEnded);

          if (!this.accessActions || !this.inlineAccess || !this.waitlistTrigger) return;
          const firstAction = nextPhase === 'live' ? this.inlineAccess : this.waitlistTrigger;
          const secondAction = nextPhase === 'live' ? this.waitlistTrigger : this.inlineAccess;
          if (this.accessActions.firstElementChild === firstAction) return;
          this.accessActions.append(firstAction, secondAction);
        }

        setPostPresaleState(isEnded) {
          const waitlistSucceeded = this.waitlistDialog?.dataset.gppWaitlistSuccess === 'true';

          if (!waitlistSucceeded) {
            if (this.waitlistEyebrow) {
              const eyebrow = isEnded
                ? this.waitlistEyebrow.dataset.endedLabel
                : this.waitlistEyebrow.dataset.defaultLabel;
              if (eyebrow) this.waitlistEyebrow.textContent = eyebrow;
            }
            if (this.waitlistHeading) {
              const heading = isEnded
                ? this.waitlistHeading.dataset.endedHeading
                : this.waitlistHeading.dataset.defaultHeading;
              if (heading) this.waitlistHeading.textContent = heading;
            }
            if (this.waitlistDescription) {
              const description = isEnded
                ? this.waitlistDescription.dataset.endedDescription
                : this.waitlistDescription.dataset.defaultDescription;
              if (description) this.waitlistDescription.textContent = description;
            }
          }

          this.updateKlaviyoSubmitLabel();
        }

        updateKlaviyoSubmitLabel() {
          if (this.dataset.presaleEnded !== 'true' || !this.klaviyoContainer) return;
          const submitLabel = this.klaviyoContainer.dataset.endedSubmitLabel;
          const submitButton = this.klaviyoContainer.querySelector('button.klaviyo-form-button');
          if (!submitLabel || !submitButton || submitButton.textContent.trim() === submitLabel) return;
          submitButton.textContent = submitLabel;
        }

        startCountdown() {
          if (!this.countdown) {
            let phase = 'waitlist';
            if (this.phaseMode === 'live') phase = 'live';
            if (this.phaseMode === 'ended') phase = 'ended';
            this.setLaunchPhase(phase);
            return;
          }

          const targetTime = Date.parse(this.countdown.dataset.target);
          const endTime = Date.parse(this.countdown.dataset.endTarget);
          const value = this.countdown.querySelector('[data-gpp-countdown-value]');
          const prefix = this.countdown.dataset.prefix || '';
          const liveLabel = this.countdown.dataset.liveLabel || '';
          const endedLabel = this.countdown.dataset.endedLabel || '';
          const daysShort = this.countdown.dataset.daysShort || '';
          const hoursShort = this.countdown.dataset.hoursShort || '';
          const minutesShort = this.countdown.dataset.minutesShort || '';
          const daysLabel = this.countdown.dataset.daysLabel || '';
          const hoursLabel = this.countdown.dataset.hoursLabel || '';
          const minutesLabel = this.countdown.dataset.minutesLabel || '';

          if (this.phaseMode === 'live') {
            this.setLaunchPhase('live');
            this.countdown.textContent = liveLabel;
            this.countdown.setAttribute('aria-label', liveLabel);
            return;
          }

          if (this.phaseMode === 'ended') {
            this.setLaunchPhase('ended');
            this.countdown.hidden = false;
            this.countdown.textContent = endedLabel;
            this.countdown.setAttribute('aria-label', endedLabel);
            return;
          }

          if (!Number.isFinite(targetTime)) {
            this.setLaunchPhase('waitlist');
            this.countdown.hidden = true;
            return;
          }

          const update = () => {
            const now = Date.now();
            const remaining = targetTime - now;

            if (this.phaseMode === 'automatic' && Number.isFinite(endTime) && now >= endTime) {
              this.setLaunchPhase('ended');
              this.countdown.hidden = false;
              this.countdown.textContent = endedLabel;
              this.countdown.setAttribute('aria-label', endedLabel);
              if (this.countdownTimer) window.clearInterval(this.countdownTimer);
              return;
            }

            if (remaining <= 0) {
              if (this.phaseMode === 'waitlist') {
                this.setLaunchPhase('waitlist');
                this.countdown.hidden = true;
                if (this.countdownTimer) window.clearInterval(this.countdownTimer);
                return;
              }

              this.setLaunchPhase('live');
              this.countdown.hidden = false;
              this.countdown.textContent = liveLabel;
              this.countdown.setAttribute('aria-label', liveLabel);
              if (!Number.isFinite(endTime) && this.countdownTimer) window.clearInterval(this.countdownTimer);
              return;
            }

            this.setLaunchPhase('waitlist');
            this.countdown.hidden = false;
            const totalMinutes = Math.floor(remaining / 60000);
            const days = Math.floor(totalMinutes / 1440);
            const hours = Math.floor((totalMinutes % 1440) / 60);
            const minutes = totalMinutes % 60;
            value.textContent = `${days}${daysShort} ${hours}${hoursShort} ${minutes}${minutesShort}`;
            this.countdown.setAttribute(
              'aria-label',
              `${prefix} ${days} ${daysLabel}, ${hours} ${hoursLabel}, ${minutes} ${minutesLabel}`
            );
          };

          this.countdownTimer = window.setInterval(update, 1000);
          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-card-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('infinite-card-carousel')) {
    class InfiniteCardCarousel extends HTMLElement {
      constructor() {
        super();
        this.elapsed = 0.5;
        this.lastTimestamp = null;
        this.frameId = null;
        this.inView = true;
        this.editorPaused = false;
        this.handleResize = this.handleResize.bind(this);
        this.handleMotionChange = this.handleMotionChange.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
        this.animate = this.animate.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.viewport = this.querySelector('.infinite-card-carousel__viewport');
        this.stage = this.querySelector('.infinite-card-carousel__stage');
        this.orbits = Array.from(this.querySelectorAll('.infinite-card-carousel__orbit'));
        this.cards = Array.from(this.querySelectorAll('.infinite-card-carousel__card'));

        if (!this.viewport || !this.stage || this.orbits.length === 0 || this.cards.length === 0) return;

        this.initialized = true;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionQuery.addEventListener('change', this.handleMotionChange);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.viewport);

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            this.inView = entries[0].isIntersecting;
            this.updateAnimation();
          },
          { rootMargin: '200px 0px' }
        );
        this.intersectionObserver.observe(this);

        this.classList.add('is-orbit-ready');
        this.measure();
        this.updateAnimation();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.stopAnimation();
        this.resizeObserver.disconnect();
        this.intersectionObserver.disconnect();
        this.motionQuery.removeEventListener('change', this.handleMotionChange);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
        this.initialized = false;
      }

      handleResize() {
        this.measure();
      }

      handleMotionChange() {
        this.updateAnimation();
      }

      handleBlockSelect() {
        this.editorPaused = true;
        this.stopAnimation();
      }

      handleBlockDeselect() {
        this.editorPaused = false;
        this.updateAnimation();
      }

      measure() {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const visibleCards = isDesktop
          ? Number(this.dataset.visibleCardsDesktop)
          : Number(this.dataset.visibleCardsMobile);
        const fanWidth = isDesktop
          ? Math.min(this.viewport.clientWidth, Number(this.dataset.fanWidthDesktop))
          : this.viewport.clientWidth;
        const edgeCrop = isDesktop
          ? Number(this.dataset.edgeCropDesktop) / 100
          : Number(this.dataset.edgeCropMobile) / 100;
        const cardSpacing = Number(this.dataset.cardSpacing) / 100;
        const bottomClearance = isDesktop
          ? Number(this.dataset.bottomClearanceDesktop)
          : Number(this.dataset.bottomClearanceMobile);
        const cardHeights = this.cards.map((card) => card.offsetHeight);
        const cardHeight = Math.max(...cardHeights);
        const cardWidth = this.cards[0].offsetWidth;
        const orbitDiameter = this.orbits[0].offsetWidth;
        const radius = orbitDiameter / 2;
        const edgeCentreX = fanWidth / 2 + cardWidth * (edgeCrop - 0.5);
        const boundaryRatio = Math.min(0.92, Math.max(0.05, edgeCentreX / radius));
        const boundaryAngle = Math.asin(boundaryRatio);
        const activeSpan = visibleCards + 1;
        const minimumSlotAngle = Math.asin(Math.min(0.75, (cardWidth * cardSpacing) / radius));
        const spacingTravelAngle = minimumSlotAngle * activeSpan / 2;
        const travelAngle = Math.min(
          Math.PI * 0.44,
          Math.max(boundaryAngle * (activeSpan / visibleCards), spacingTravelAngle)
        );

        this.layout = {
          viewportWidth: this.viewport.clientWidth,
          cardWidth,
          cardHeight,
          visibleCards,
          activeSpan,
          travelAngle,
          speed: Number(this.dataset.animationSpeed) / 100
        };

        const orbitBaseTop = cardHeight / 2;
        const rotationOffsets = this.cards.map((card) => {
          const value = getComputedStyle(card).getPropertyValue('--rotation-offset');
          return (Number.parseFloat(value) || 0) * Math.PI / 180;
        });
        let highestCardEdge = 0;
        let lowestCardEdge = cardHeight;
        const sampleCount = 64;

        rotationOffsets.forEach((rotationOffset) => {
          for (let sample = 0; sample <= sampleCount; sample += 1) {
            const orbitAngle = -travelAngle + (travelAngle * 2 * sample) / sampleCount;
            const cardAngle = orbitAngle + rotationOffset;
            const centreY = orbitBaseTop + radius * (1 - Math.cos(orbitAngle));
            const halfExtentY =
              Math.abs(Math.sin(cardAngle)) * cardWidth / 2
              + Math.abs(Math.cos(cardAngle)) * cardHeight / 2;

            highestCardEdge = Math.min(highestCardEdge, centreY - halfExtentY);
            lowestCardEdge = Math.max(lowestCardEdge, centreY + halfExtentY);
          }
        });

        /*
         * The transition cards briefly travel far down the circle after they
         * have moved beyond the viewport edge. Letting those invisible points
         * size the stage creates a large blank area below the fan, so only
         * reserve the useful visible arc depth.
         */
        const visibleArcDepth = Math.min(
          Math.max(0, lowestCardEdge - cardHeight),
          cardWidth * 0.32
        );
        const topInset = Math.ceil(Math.max(0, -highestCardEdge) + 12);
        const orbitTop = orbitBaseTop + topInset;

        this.stage.style.height = `${Math.ceil(
          topInset + cardHeight + visibleArcDepth + bottomClearance
        )}px`;
        this.orbits.forEach((orbit) => {
          orbit.style.top = `${orbitTop}px`;
        });
        this.renderFrame(this.motionQuery.matches ? 0 : this.elapsed);
      }

      updateAnimation() {
        if (this.motionQuery.matches) {
          this.stopAnimation();
          this.renderFrame(0);
          return;
        }

        if (!this.inView || this.editorPaused) {
          this.stopAnimation();
          return;
        }

        if (this.frameId === null) {
          this.frameId = requestAnimationFrame(this.animate);
        }
      }

      stopAnimation() {
        if (this.frameId !== null) {
          cancelAnimationFrame(this.frameId);
          this.frameId = null;
        }

        this.lastTimestamp = null;
      }

      animate(timestamp) {
        if (this.lastTimestamp !== null) {
          const delta = Math.min((timestamp - this.lastTimestamp) / 1000, 0.1);
          this.elapsed += delta;
        }

        this.lastTimestamp = timestamp;
        this.renderFrame(this.elapsed);
        this.frameId = requestAnimationFrame(this.animate);
      }

      renderFrame(elapsed) {
        if (!this.layout) return;

        const totalCards = this.orbits.length;
        const activeSpan = this.layout.activeSpan;

        this.orbits.forEach((orbit, index) => {
          const phase = (index + elapsed * this.layout.speed) % totalCards;

          if (phase >= activeSpan) {
            orbit.style.visibility = 'hidden';
            orbit.style.opacity = '0';
            return;
          }

          const progress = phase / activeSpan;
          const angle = this.layout.travelAngle - progress * this.layout.travelAngle * 2;
          const edgeDistance = Math.min(phase, activeSpan - phase);
          const opacity = Math.min(1, edgeDistance / 0.4);
          const angleDegrees = (angle * 180) / Math.PI;

          orbit.style.visibility = 'visible';
          orbit.style.opacity = String(opacity);
          orbit.style.zIndex = String(Math.round(10 + (activeSpan - phase) * 10));
          orbit.style.transform = `translate3d(-50%, 0, 0) rotate(${angleDegrees}deg)`;
        });
      }
    }

    customElements.define('infinite-card-carousel', InfiniteCardCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presell-before-after-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('presell-before-after-carousel')) {
    class PresellBeforeAfterCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot-index]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        this.swipeHint = this.querySelector('[data-swipe-hint]');

        if (!this.viewport || !this.track || this.slides.length === 0) return;

        this.initialized = true;
        this.desktopIndex = 0;
        this.activeIndex = 0;
        this.scrollFrame = null;
        this.desktopQuery = window.matchMedia('(min-width: 990px)');

        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);

        this.previousButton?.addEventListener('click', () => this.setDesktopIndex(this.desktopIndex - 1));
        this.nextButton?.addEventListener('click', () => this.setDesktopIndex(this.desktopIndex + 1));
        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.scrollToSlide(Number(dot.dataset.dotIndex)));
        });

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.viewport);
        this.observeSwipeHint();
        this.refresh();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.hintObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.initialized = false;
      }

      observeSwipeHint() {
        if (!this.swipeHint || !('IntersectionObserver' in window)) return;

        this.hintObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          this.classList.add('is-swipe-hint-visible');
          this.hintObserver.disconnect();
        }, { threshold: 0.6 });

        this.hintObserver.observe(this.swipeHint);
      }

      handleResize() {
        this.refresh();
      }

      handleScroll() {
        if (this.desktopQuery.matches || this.scrollFrame) return;

        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateMobileIndex();
        });
      }

      handleKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;

        if (this.desktopQuery.matches) {
          this.setDesktopIndex(this.desktopIndex + direction);
        } else {
          this.scrollToSlide(this.activeIndex + direction);
        }
      }

      handleBlockSelect(event) {
        const selectedSlide = event.target.closest('[data-slide]');
        if (!selectedSlide) return;

        const selectedIndex = this.slides.indexOf(selectedSlide);
        if (selectedIndex < 0) return;

        if (this.desktopQuery.matches) {
          this.setDesktopIndex(Math.min(selectedIndex, this.maximumDesktopIndex()));
        } else {
          this.scrollToSlide(selectedIndex);
        }
      }

      maximumDesktopIndex() {
        return Math.max(0, this.slides.length - 3);
      }

      setDesktopIndex(index) {
        const nextIndex = Math.max(0, Math.min(index, this.maximumDesktopIndex()));
        this.desktopIndex = nextIndex;

        const firstOffset = this.slides[0]?.offsetLeft || 0;
        const targetOffset = (this.slides[nextIndex]?.offsetLeft || firstOffset) - firstOffset;
        this.track.style.transform = `translate3d(${-targetOffset}px, 0, 0)`;
        this.updateArrowState();
        this.updateStatus(nextIndex);
      }

      scrollToSlide(index) {
        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const firstOffset = this.slides[0]?.offsetLeft || 0;
        const targetOffset = (this.slides[nextIndex]?.offsetLeft || firstOffset) - firstOffset;

        this.viewport.scrollTo({
          left: targetOffset,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        this.setActiveIndex(nextIndex);
      }

      updateMobileIndex() {
        const firstOffset = this.slides[0]?.offsetLeft || 0;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const slideOffset = slide.offsetLeft - firstOffset;
          const distance = Math.abs(slideOffset - this.viewport.scrollLeft);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.setActiveIndex(nearestIndex);
      }

      setActiveIndex(index) {
        this.activeIndex = index;
        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
        this.updateStatus(index);
      }

      updateArrowState() {
        if (!this.previousButton || !this.nextButton) return;

        this.previousButton.disabled = this.desktopIndex <= 0;
        this.nextButton.disabled = this.desktopIndex >= this.maximumDesktopIndex();
      }

      updateStatus(index) {
        if (!this.status) return;
        this.status.textContent = `Showing result ${index + 1} of ${this.slides.length}`;
      }

      refresh() {
        if (this.desktopQuery.matches) {
          this.viewport.scrollLeft = 0;
          this.setDesktopIndex(this.desktopIndex);
        } else {
          this.track.style.transform = '';
          this.updateMobileIndex();
        }
      }
    }

    customElements.define('presell-before-after-carousel', PresellBeforeAfterCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presell-daily-ritual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('presell-daily-ritual-carousel')) {
    class PresellDailyRitualCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('.presell-daily-ritual__step'));
        this.status = this.querySelector('[data-status]');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.scrollFrame = null;
        this.activeIndex = 0;

        if (!this.viewport || !this.track || this.slides.length === 0) return;

        this.initialized = true;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);

        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.handleResize);
        } else {
          this.mobileQuery.addListener(this.handleResize);
        }

        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this.viewport);
        }

        this.refresh();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);

        if (this.mobileQuery) {
          if (this.mobileQuery.removeEventListener) {
            this.mobileQuery.removeEventListener('change', this.handleResize);
          } else {
            this.mobileQuery.removeListener(this.handleResize);
          }
        }

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.initialized = false;
      }

      isMobile() {
        return this.mobileQuery.matches;
      }

      handleResize() {
        this.refresh();
      }

      handleScroll() {
        if (!this.isMobile() || this.scrollFrame) return;

        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateMobileIndex();
        });
      }

      handleKeydown(event) {
        if (!this.isMobile() || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.scrollToSlide(this.activeIndex + direction);
      }

      handleBlockSelect(event) {
        const selectedSlide = event.target.closest('.presell-daily-ritual__step');
        if (!selectedSlide) return;

        const selectedIndex = this.slides.indexOf(selectedSlide);
        if (selectedIndex >= 0) this.scrollToSlide(selectedIndex);
      }

      scrollToSlide(index) {
        if (!this.isMobile()) return;

        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const firstOffset = this.slides[0]?.offsetLeft || 0;
        const targetOffset = (this.slides[nextIndex]?.offsetLeft || firstOffset) - firstOffset;

        this.viewport.scrollTo({
          left: targetOffset,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        this.setActiveIndex(nextIndex);
      }

      updateMobileIndex() {
        if (!this.isMobile()) return;

        const firstOffset = this.slides[0]?.offsetLeft || 0;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const slideOffset = slide.offsetLeft - firstOffset;
          const distance = Math.abs(slideOffset - this.viewport.scrollLeft);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.setActiveIndex(nearestIndex);
      }

      setActiveIndex(index) {
        this.activeIndex = Math.max(0, Math.min(index, this.slides.length - 1));

        if (this.status) {
          this.status.textContent = `Showing step ${this.activeIndex + 1} of ${this.slides.length}`;
        }
      }

      refresh() {
        if (this.isMobile()) {
          this.updateMobileIndex();
          return;
        }

        this.viewport.scrollLeft = 0;
        this.setActiveIndex(0);
      }
    }

    customElements.define('presell-daily-ritual-carousel', PresellDailyRitualCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presell-ingredients"] && !Shopify.designMode) return;
  try {
    
  class IngredientFocusCarousel {
    constructor(root) {
      if (root.dataset.ingredientReady === 'true') return;
      root.dataset.ingredientReady = 'true';
      this.root = root;
      this.stage = root.querySelector('[data-ingredient-stage]');
      this.slides = Array.from(root.querySelectorAll('[data-ingredient-slide]'));
      this.previousButton = root.querySelector('[data-carousel-previous]');
      this.nextButton = root.querySelector('[data-carousel-next]');
      this.activeIndex = 0;
      this.position = 0;
      this.targetPosition = 0;
      this.animationFrame = null;
      this.dragFrame = null;
      this.lastFrameTime = 0;
      this.pendingFocus = false;
      this.pointer = null;
      this.drawerPointer = null;
      this.drawerHintTimer = null;
      this.drawerHintEndTimer = null;
      this.drawerHintDialog = null;
      this.hasShownDrawerHint = false;
      this.lastTrigger = null;
      this.suppressClickUntil = 0;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.drawerMotionDuration = this.prefersReducedMotion ? 0 : 520;
      this.drawerSwipeDuration = this.prefersReducedMotion ? 0 : 360;
      this.bind();
      this.render(false);
      this.root.classList.add('is-motion-controlled');
      this.renderMotion();
    }

    bind() {
      this.previousButton?.addEventListener('click', () => this.move(-1));
      this.nextButton?.addEventListener('click', () => this.move(1));

      this.slides.forEach((slide, index) => {
        const mediaButton = slide.querySelector('[data-slide-action]');

        mediaButton?.addEventListener('click', (event) => {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          const position = slide.dataset.position;
          if (position === 'previous') {
            this.move(-1);
          } else if (position === 'next') {
            this.move(1);
          } else if (position === 'active') {
            this.openDialog(mediaButton);
          }
        });

        mediaButton?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(-1, true);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(1, true);
          }
        });

        slide.addEventListener('click', (event) => {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            return;
          }
          if (event.target.closest('button, a')) return;
          if (slide.dataset.position === 'previous') this.move(-1);
          if (slide.dataset.position === 'next') this.move(1);
          if (slide.dataset.position === 'active') this.openDialog(mediaButton);
        });

        slide.dataset.slideIndex = String(index);
      });

      this.stage?.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.stage?.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.stage?.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.stage?.addEventListener('pointercancel', (event) => this.onPointerCancel(event));
      window.addEventListener('resize', () => this.renderMotion(false));

      this.root.querySelectorAll('[data-ingredient-dialog]').forEach((dialog) => {
        if (dialog.classList.contains('ingredient-focus__drawer')) {
          this.bindDrawerSwipe(dialog);
        }

        dialog.addEventListener('click', (event) => {
          if (event.target.closest('[data-dialog-close]')) {
            this.closeDialog(dialog);
            return;
          }
          if (event.target === dialog) this.closeDialog(dialog);
        });

        dialog.addEventListener('cancel', (event) => {
          if (!dialog.classList.contains('ingredient-focus__drawer')) return;
          event.preventDefault();
          this.closeDialog(dialog);
        });

        dialog.addEventListener('close', () => {
          this.resetDrawerSwipe(dialog);
          dialog.classList.remove('is-opening', 'is-closing');
          this.root.classList.remove('is-dialog-open');
          document.documentElement.style.overflow = '';
          const trigger = this.lastTrigger;
          if (!trigger) return;

          trigger.classList.add('is-dialog-restored');
          trigger.focus({ preventScroll: true });

          const clearRestoredFocus = () => trigger.classList.remove('is-dialog-restored');
          trigger.addEventListener('blur', clearRestoredFocus, { once: true });
          trigger.addEventListener('keydown', clearRestoredFocus, { once: true });
        });
      });
    }

    move(direction, shouldFocus = false) {
      if (this.slides.length < 2 || this.root.classList.contains('is-dialog-open')) return;
      this.targetPosition += direction;
      if (this.prefersReducedMotion) {
        this.position = this.targetPosition;
        this.renderMotion(shouldFocus);
        return;
      }
      this.startMotion(shouldFocus);
    }

    startMotion(shouldFocus = false) {
      this.pendingFocus = this.pendingFocus || shouldFocus;
      if (this.animationFrame) return;
      this.lastFrameTime = 0;

      const step = (time) => {
        if (!this.lastFrameTime) this.lastFrameTime = time;
        const elapsed = Math.min(40, Math.max(1, time - this.lastFrameTime));
        this.lastFrameTime = time;
        const distance = this.targetPosition - this.position;
        const blend = 1 - Math.exp(-elapsed / 90);

        this.position += distance * blend;

        if (Math.abs(this.targetPosition - this.position) < 0.001) {
          this.position = this.targetPosition;
          this.animationFrame = null;
          this.lastFrameTime = 0;
          this.renderMotion(this.pendingFocus);
          this.pendingFocus = false;
          return;
        }

        this.renderMotion(false);
        this.animationFrame = window.requestAnimationFrame(step);
      };

      this.animationFrame = window.requestAnimationFrame(step);
    }

    stopMotion() {
      if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      this.lastFrameTime = 0;
      this.pendingFocus = false;
    }

    onPointerDown(event) {
      if (
        this.slides.length < 2
        || this.root.classList.contains('is-dialog-open')
        || !event.isPrimary
        || (event.pointerType === 'mouse' && event.button !== 0)
      ) {
        return;
      }

      this.stopMotion();
      this.cancelDragRender();
      this.targetPosition = this.position;
      this.pointer = {
        id: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startTime: performance.now(),
        startPosition: this.position,
        lastX: event.clientX,
        lastTime: performance.now(),
        velocity: 0,
        dragX: 0,
        locked: false
      };
    }

    onPointerMove(event) {
      if (!this.pointer || event.pointerId !== this.pointer.id) return;

      const distanceX = event.clientX - this.pointer.startX;
      const distanceY = event.clientY - this.pointer.startY;

      if (!this.pointer.locked) {
        if (Math.abs(distanceX) < 8 && Math.abs(distanceY) < 8) return;
        if (Math.abs(distanceY) >= Math.abs(distanceX)) {
          this.pointer = null;
          return;
        }

        this.pointer.locked = true;
        this.root.classList.add('is-dragging');
        this.stage?.setPointerCapture?.(event.pointerId);
      }

      event.preventDefault();
      const travel = this.getDragTravel();
      const now = performance.now();
      const sampleTime = Math.max(1, now - this.pointer.lastTime);
      const sampleVelocity = (event.clientX - this.pointer.lastX) / sampleTime;

      this.pointer.velocity = (this.pointer.velocity * 0.55) + (sampleVelocity * 0.45);
      this.pointer.lastX = event.clientX;
      this.pointer.lastTime = now;
      this.pointer.dragX = distanceX;
      const anchorPosition = Math.round(this.pointer.startPosition);
      const rawPosition = this.pointer.startPosition - (distanceX / travel);
      this.position = this.clamp(rawPosition, anchorPosition - 1.08, anchorPosition + 1.08);
      this.targetPosition = this.position;
      this.scheduleDragRender();
    }

    onPointerUp(event) {
      if (!this.pointer || event.pointerId !== this.pointer.id) return;
      if (!this.pointer.locked) {
        this.pointer = null;
        return;
      }

      event.preventDefault();
      const travel = this.getDragTravel();
      const velocityInSlides = -this.pointer.velocity / travel;
      const projectedPosition = this.position + (velocityInSlides * 140);
      const anchorPosition = Math.round(this.pointer.startPosition);
      const projectedTarget = Math.round(projectedPosition);

      this.targetPosition = this.clamp(projectedTarget, anchorPosition - 1, anchorPosition + 1);
      this.suppressClickUntil = performance.now() + 320;
      this.cancelDragRender();
      this.releasePointer(event.pointerId);
      this.pointer = null;
      this.root.classList.remove('is-dragging');
      this.startMotion(false);
    }

    onPointerCancel(event) {
      if (!this.pointer || event.pointerId !== this.pointer.id) return;
      const wasDragging = this.pointer.locked;
      const anchorPosition = Math.round(this.pointer.startPosition);
      this.releasePointer(event.pointerId);
      this.cancelDragRender();
      this.pointer = null;
      if (wasDragging) {
        this.targetPosition = this.clamp(Math.round(this.position), anchorPosition - 1, anchorPosition + 1);
        this.root.classList.remove('is-dragging');
        this.startMotion(false);
      }
    }

    releasePointer(pointerId) {
      if (!this.stage?.hasPointerCapture?.(pointerId)) return;
      this.stage.releasePointerCapture(pointerId);
    }

    scheduleDragRender() {
      if (this.dragFrame) return;
      this.dragFrame = window.requestAnimationFrame(() => {
        this.dragFrame = null;
        this.renderMotion(false);
      });
    }

    cancelDragRender() {
      if (this.dragFrame) window.cancelAnimationFrame(this.dragFrame);
      this.dragFrame = null;
    }

    getMotionMetrics() {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      const viewportWidth = window.innerWidth;
      const cardWidth = this.slides[this.activeIndex]?.offsetWidth || (isDesktop ? 350 : 260);
      const sideScale = isDesktop ? 0.8 : 0.82;
      const farScale = isDesktop ? 0.68 : 0.7;
      const sideX = isDesktop
        ? this.clamp(viewportWidth * 0.245, 276, 330)
        : (cardWidth * ((1 + sideScale) / 2)) + 12;
      const farX = isDesktop
        ? (viewportWidth / 2) + (cardWidth * farScale * 0.08)
        : sideX * 2;
      const sideY = isDesktop
        ? this.clamp(viewportWidth * 0.025, 27, 34)
        : Math.min(viewportWidth * 0.048, 19);
      const farY = isDesktop
        ? this.clamp(viewportWidth * 0.04, 44, 54)
        : Math.min(viewportWidth * 0.096, 38);

      return { cardWidth, farScale, farX, farY, isDesktop, sideScale, sideX, sideY };
    }

    getDragTravel() {
      return this.getMotionMetrics().sideX;
    }

    lerp(start, end, progress) {
      return start + ((end - start) * progress);
    }

    clamp(value, minimum, maximum) {
      return Math.min(maximum, Math.max(minimum, value));
    }

    wrapIndex(index) {
      return ((index % this.slides.length) + this.slides.length) % this.slides.length;
    }

    relativeOffset(index) {
      const normalizedPosition = this.wrapIndex(this.position);
      let offset = index - normalizedPosition;
      const midpoint = this.slides.length / 2;
      if (offset > midpoint) offset -= this.slides.length;
      if (offset < -midpoint) offset += this.slides.length;
      return offset;
    }

    renderMotion(shouldFocus = false) {
      const nearestIndex = this.wrapIndex(Math.round(this.position));
      if (nearestIndex !== this.activeIndex) {
        this.activeIndex = nearestIndex;
        this.render(shouldFocus);
      }

      const { farScale, farX, farY, isDesktop, sideScale, sideX, sideY } = this.getMotionMetrics();

      this.slides.forEach((slide, index) => {
        const offset = this.relativeOffset(index);
        const absoluteOffset = Math.abs(offset);

        if (absoluteOffset > 2.05) {
          if (slide.dataset.motionVisible !== 'false') {
            slide.dataset.motionVisible = 'false';
            slide.style.opacity = '0';
            slide.style.visibility = 'hidden';
            slide.style.pointerEvents = 'none';
            slide.style.zIndex = '0';
          }
          return;
        }

        slide.dataset.motionVisible = 'true';
        const direction = Math.sign(offset);
        const nearProgress = Math.min(1, absoluteOffset);
        const farProgress = Math.min(1, Math.max(0, absoluteOffset - 1));
        const x = absoluteOffset <= 1
          ? sideX * nearProgress
          : this.lerp(sideX, farX, farProgress);
        const y = absoluteOffset <= 1
          ? this.lerp(0, sideY, nearProgress)
          : this.lerp(sideY, farY, farProgress);
        const scale = absoluteOffset <= 1
          ? this.lerp(1, sideScale, nearProgress)
          : this.lerp(sideScale, farScale, farProgress);
        const opacity = absoluteOffset <= 1
          ? 1
          : this.lerp(1, isDesktop ? 0 : 0.58, farProgress);

        slide.style.transform = `translate(calc(-50% + ${direction * x}px), ${y}px) scale(${scale})`;
        slide.style.opacity = String(opacity);
        slide.style.visibility = opacity > 0.02 ? 'visible' : 'hidden';
        slide.style.pointerEvents = absoluteOffset <= 1.05 ? 'auto' : 'none';
        slide.style.zIndex = absoluteOffset < 0.5 ? '3' : absoluteOffset < 1.5 ? '1' : '0';
      });

      if (shouldFocus) {
        this.slides[this.activeIndex]?.querySelector('[data-slide-action]')?.focus({ preventScroll: true });
      }
    }

    render(shouldFocus) {
      const previousIndex = (this.activeIndex - 1 + this.slides.length) % this.slides.length;
      const nextIndex = (this.activeIndex + 1) % this.slides.length;
      const farPreviousIndex = (this.activeIndex - 2 + this.slides.length) % this.slides.length;
      const farNextIndex = (this.activeIndex + 2) % this.slides.length;

      this.slides.forEach((slide, index) => {
        let position = 'hidden';
        if (this.slides.length > 4 && index === farPreviousIndex) position = 'far-previous';
        if (index === this.activeIndex) position = 'active';
        if (this.slides.length > 1 && index === previousIndex) position = 'previous';
        if (this.slides.length > 2 && index === nextIndex) position = 'next';
        if (this.slides.length > 4 && index === farNextIndex) position = 'far-next';

        slide.dataset.position = position;
        slide.classList.toggle('is-active', position === 'active');
        slide.classList.toggle('is-previous', position === 'previous');
        slide.classList.toggle('is-next', position === 'next');
        slide.classList.toggle('is-far-previous', position === 'far-previous');
        slide.classList.toggle('is-far-next', position === 'far-next');
        slide.classList.toggle('is-hidden', position === 'hidden');
        slide.setAttribute('aria-hidden', String(position !== 'active'));

        const mediaButton = slide.querySelector('[data-slide-action]');
        if (mediaButton) mediaButton.tabIndex = position === 'active' ? 0 : -1;
      });

      if (shouldFocus) this.slides[this.activeIndex]?.querySelector('[data-slide-action]')?.focus({ preventScroll: true });
    }

    bindDrawerSwipe(dialog) {
      const surface = dialog.querySelector('.ingredient-focus__drawer-scroll');
      if (!surface) return;

      surface.addEventListener('pointerdown', (event) => this.onDrawerPointerDown(event, dialog, surface));
      surface.addEventListener('pointermove', (event) => this.onDrawerPointerMove(event, dialog));
      surface.addEventListener('pointerup', (event) => this.onDrawerPointerUp(event, dialog));
      surface.addEventListener('pointercancel', (event) => this.onDrawerPointerCancel(event, dialog));
    }

    onDrawerPointerDown(event, dialog, surface) {
      if (this.drawerHintTimer || dialog.classList.contains('is-gesture-hinting')) {
        this.hasShownDrawerHint = true;
        this.cancelDrawerHint(dialog);
      }

      if (
        !dialog.open
        || !event.isPrimary
        || (event.pointerType === 'mouse' && event.button !== 0)
      ) {
        return;
      }

      this.drawerPointer = {
        id: event.pointerId,
        dialog,
        surface,
        startX: event.clientX,
        startY: event.clientY,
        startTime: performance.now(),
        dragX: 0,
        locked: false
      };
    }

    onDrawerPointerMove(event, dialog) {
      const pointer = this.drawerPointer;
      if (!pointer || pointer.dialog !== dialog || event.pointerId !== pointer.id) return;

      const distanceX = event.clientX - pointer.startX;
      const distanceY = event.clientY - pointer.startY;

      if (!pointer.locked) {
        if (Math.abs(distanceX) < 8 && Math.abs(distanceY) < 8) return;
        if (Math.abs(distanceY) >= Math.abs(distanceX) || distanceX < 0) {
          this.drawerPointer = null;
          return;
        }

        pointer.locked = true;
        dialog.classList.add('is-swiping');
        pointer.surface.setPointerCapture?.(event.pointerId);
      }

      event.preventDefault();
      const width = dialog.offsetWidth || 560;
      const overflow = Math.max(0, distanceX - width);
      const resistedDistance = Math.min(distanceX, width) + (overflow * 0.18);
      const progress = Math.min(1, resistedDistance / width);

      pointer.dragX = resistedDistance;
      dialog.style.setProperty('--ingredient-drawer-drag-x', `${resistedDistance}px`);
      dialog.style.setProperty('--ingredient-drawer-backdrop-opacity', String(0.62 * (1 - progress)));
    }

    onDrawerPointerUp(event, dialog) {
      const pointer = this.drawerPointer;
      if (!pointer || pointer.dialog !== dialog || event.pointerId !== pointer.id) return;
      if (!pointer.locked) {
        this.drawerPointer = null;
        return;
      }

      event.preventDefault();
      const elapsed = Math.max(1, performance.now() - pointer.startTime);
      const velocity = pointer.dragX / elapsed;
      const width = dialog.offsetWidth || 560;
      const shouldClose = pointer.dragX >= width * 0.25 || velocity >= 0.5;

      this.releaseDrawerPointer(pointer);
      this.drawerPointer = null;
      this.settleDrawerSwipe(dialog, shouldClose);
    }

    onDrawerPointerCancel(event, dialog) {
      const pointer = this.drawerPointer;
      if (!pointer || pointer.dialog !== dialog || event.pointerId !== pointer.id) return;
      const wasDragging = pointer.locked;
      this.releaseDrawerPointer(pointer);
      this.drawerPointer = null;
      if (wasDragging) this.settleDrawerSwipe(dialog, false);
    }

    releaseDrawerPointer(pointer) {
      if (!pointer.surface?.hasPointerCapture?.(pointer.id)) return;
      pointer.surface.releasePointerCapture(pointer.id);
    }

    settleDrawerSwipe(dialog, shouldClose) {
      dialog.classList.remove('is-swiping');
      dialog.classList.add('is-swipe-settling');
      const targetX = shouldClose ? dialog.offsetWidth : 0;
      const targetBackdrop = shouldClose ? 0 : 0.62;

      dialog.getBoundingClientRect();
      window.requestAnimationFrame(() => {
        dialog.style.setProperty('--ingredient-drawer-drag-x', `${targetX}px`);
        dialog.style.setProperty('--ingredient-drawer-backdrop-opacity', String(targetBackdrop));
      });

      if (this.drawerSwipeDuration === 0) {
        if (shouldClose) dialog.close();
        else this.resetDrawerSwipe(dialog);
        return;
      }

      window.setTimeout(() => {
        if (shouldClose) {
          if (dialog.open) dialog.close();
        } else {
          this.resetDrawerSwipe(dialog);
        }
      }, this.drawerSwipeDuration);
    }

    resetDrawerSwipe(dialog) {
      this.cancelDrawerHint(dialog);
      if (this.drawerPointer?.dialog === dialog) {
        this.releaseDrawerPointer(this.drawerPointer);
        this.drawerPointer = null;
      }
      dialog.classList.remove('is-swiping', 'is-swipe-settling');
      dialog.style.removeProperty('--ingredient-drawer-drag-x');
      dialog.style.removeProperty('--ingredient-drawer-backdrop-opacity');
    }

    scheduleDrawerHint(dialog) {
      if (
        this.hasShownDrawerHint
        || this.prefersReducedMotion
        || !window.matchMedia('(max-width: 989px)').matches
      ) {
        return;
      }

      this.cancelDrawerHint(dialog);
      this.drawerHintDialog = dialog;
      this.drawerHintTimer = window.setTimeout(() => {
        this.drawerHintTimer = null;
        if (!dialog.open || this.drawerPointer || dialog.classList.contains('is-closing')) {
          this.drawerHintDialog = null;
          return;
        }

        this.hasShownDrawerHint = true;
        dialog.classList.add('is-gesture-hinting');
        this.drawerHintEndTimer = window.setTimeout(() => {
          dialog.classList.remove('is-gesture-hinting');
          this.drawerHintEndTimer = null;
          this.drawerHintDialog = null;
        }, 620);
      }, 720);
    }

    cancelDrawerHint(dialog) {
      if (this.drawerHintDialog !== dialog) {
        dialog.classList.remove('is-gesture-hinting');
        return;
      }

      if (this.drawerHintTimer) window.clearTimeout(this.drawerHintTimer);
      if (this.drawerHintEndTimer) window.clearTimeout(this.drawerHintEndTimer);
      this.drawerHintTimer = null;
      this.drawerHintEndTimer = null;
      this.drawerHintDialog = null;
      dialog.classList.remove('is-gesture-hinting');
    }

    cancelCarouselPointer() {
      if (this.pointer) this.releasePointer(this.pointer.id);
      this.pointer = null;
      this.cancelDragRender();
      this.stopMotion();
      this.targetPosition = Math.round(this.position);
      this.position = this.targetPosition;
      this.root.classList.remove('is-dragging');
      this.renderMotion(false);
    }

    openDialog(trigger) {
      if (!trigger) return;
      const dialogId = trigger.dataset.dialogId;
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog || typeof dialog.showModal !== 'function') return;
      this.cancelCarouselPointer();
      this.lastTrigger = trigger;
      this.root.classList.add('is-dialog-open');
      this.resetDrawerSwipe(dialog);
      if (dialog.classList.contains('ingredient-focus__drawer')) dialog.classList.add('is-opening');
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (dialog.classList.contains('ingredient-focus__drawer')) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            dialog.classList.remove('is-opening');
            this.scheduleDrawerHint(dialog);
          });
        });
      }
    }

    closeDialog(dialog) {
      if (!dialog?.open) return;
      this.resetDrawerSwipe(dialog);
      if (!dialog.classList.contains('ingredient-focus__drawer') || this.drawerMotionDuration === 0) {
        dialog.close();
        return;
      }
      if (dialog.classList.contains('is-closing')) return;
      dialog.classList.add('is-closing');
      window.setTimeout(() => {
        if (dialog.open) dialog.close();
      }, this.drawerMotionDuration);
    }
  }

  function initIngredientFocus(scope = document) {
    scope.querySelectorAll('[data-ingredient-focus]').forEach((root) => {
      new IngredientFocusCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initIngredientFocus());
  } else {
    initIngredientFocus();
  }

  document.addEventListener('shopify:section:load', (event) => initIngredientFocus(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-ingredient-slide]');
    const root = slide?.closest('[data-ingredient-focus]');
    if (!slide || !root) return;
    const mediaButton = slide.querySelector('[data-slide-action]');
    mediaButton?.click();
  });

  } catch(e) { console.error(e); }
})();
})();
